import { Link } from "wouter";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
// import vcaLogo from "@/assets/vca-logo.png";

export default function Footer() {
  return (
    <footer className="bg-navy text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <div className="h-8 w-8 bg-white rounded-full flex items-center justify-center text-navy font-bold text-sm mr-2">
                VCA
              </div>
              <span className="text-xl font-bold">VCA</span>
            </div>
            <p className="text-gray-300 text-sm">
              Vaal Cruising Association - Fostering boating excellence and community on the Vaal Dam since 1968.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/rules" className="text-gray-300 hover:text-sailing-gold transition-colors">
                  Club Rules
                </Link>
              </li>
              <li>
                <Link href="/gallery" className="text-gray-300 hover:text-sailing-gold transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <a href="https://admin.vaalcruising.co.za/login" className="text-gray-300 hover:text-sailing-gold transition-colors">
                  Admin Login
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p className="flex items-center">
                <Mail className="mr-2 h-4 w-4" />
                info@vaalcruising.co.za
              </p>
              <div className="flex items-center space-x-2">
                <Phone className="mr-2 h-4 w-4" />
                <span>016 004 0192</span>
                <a
                  href="tel:+27160040192"
                  className="text-sailing-gold hover:text-white transition-colors"
                  title="Call us"
                >
                  <Phone className="h-4 w-4" />
                </a>
                <a
                  href="https://wa.me/27160040192"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sailing-gold hover:text-white transition-colors"
                  title="WhatsApp us"
                >
                  <MessageCircle className="h-4 w-4" />
                </a>
              </div>
              <p className="flex items-center">
                <MapPin className="mr-2 h-4 w-4" />
                <a href="https://maps.app.goo.gl/DQjhQvyN9BoTwrUm7" target="_blank" rel="noopener noreferrer" className="hover:text-sailing-gold transition-colors">
                  Aloe Fjord, Vaal Dam, Gauteng
                </a>
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/vaalcruising/"
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-sailing-gold transition-colors text-xl"
              >
                <FaFacebook />
              </a>
              <a 
                href="https://www.instagram.com/vaalcruising" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-sailing-gold transition-colors text-xl"
              >
                <FaInstagram />
              </a>
            </div>
            <div className="mt-4">
              <p className="text-xs text-gray-400">Stay updated with club events and boating news</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-600 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-300">
            <p>&copy; 2026 Vaal Cruising Association. All rights reserved.</p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <Link href="/privacy-policy" className="hover:text-sailing-gold transition-colors">Privacy Policy</Link>
              <Link href="/terms-of-service" className="hover:text-sailing-gold transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
